module.exports = {
  "zones": {
    "America/Bahia_Banderas": ["z", {
      "wallclock": 1270346400000,
      "format": "C%sT",
      "abbrev": "CDT",
      "offset": -21600000,
      "posix": 1270371600000,
      "save": 3600000,
      "rules": "Mexico"
    }, {
      "wallclock": 0,
      "format": "M%sT",
      "abbrev": "MST",
      "offset": -25200000,
      "posix": 28800000,
      "save": 0,
      "rules": "Mexico"
    }, {
      "wallclock": -661564800000,
      "format": "PST",
      "abbrev": "PST",
      "offset": -28800000,
      "posix": -661539600000,
      "save": 0
    }, {
      "wallclock": -873849600000,
      "format": "MST",
      "abbrev": "MST",
      "offset": -25200000,
      "posix": -873828000000,
      "save": 0
    }, {
      "wallclock": -1191369600000,
      "format": "CST",
      "abbrev": "CST",
      "offset": -21600000,
      "posix": -1191344400000,
      "save": 0
    }, {
      "wallclock": -1207180800000,
      "format": "MST",
      "abbrev": "MST",
      "offset": -25200000,
      "posix": -1207159200000,
      "save": 0
    }, {
      "wallclock": -1220317200000,
      "format": "CST",
      "abbrev": "CST",
      "offset": -21600000,
      "posix": -1220292000000,
      "save": 0
    }, {
      "wallclock": -1234828800000,
      "format": "MST",
      "abbrev": "MST",
      "offset": -25200000,
      "posix": -1234807200000,
      "save": 0
    }, {
      "wallclock": -1343091600000,
      "format": "CST",
      "abbrev": "CST",
      "offset": -21600000,
      "posix": -1343066400000,
      "save": 0
    }, {
      "wallclock": -1514764860000,
      "format": "MST",
      "abbrev": "MST",
      "offset": -25200000,
      "posix": -1514739600000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -25260000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Mexico": [{
      "from": 2002,
      "to": 1.7976931348623157e+308,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 2002,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 2001,
      "to": 2001,
      "month": 4,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 2001,
      "to": 2001,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1996,
      "to": 2000,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1996,
      "to": 2000,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1950,
      "to": 1950,
      "month": 1,
      "day": [7, 12],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1950,
      "to": 1950,
      "month": 6,
      "day": [7, 30],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1944,
      "to": 1944,
      "month": 4,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1943,
      "to": 1943,
      "month": 11,
      "day": [7, 16],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "W",
      "saved": 0
    }, {
      "from": 1941,
      "to": 1941,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1940,
      "to": 1940,
      "month": 11,
      "day": [7, 9],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1939,
      "to": 1939,
      "month": 1,
      "day": [7, 5],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1939,
      "to": 1939,
      "month": 5,
      "day": [7, 25],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 0
    }]
  }
};